import { actionTypes, ConfigAction, ConfigState } from './configTypes';

export const beginApiCall = () => ({
  type: actionTypes.BEGIN_API_CALL,
});

export const endApiCall = () => ({
  type: actionTypes.END_API_CALL,
});

const initialState: ConfigState = {
  ui: {
    theme: 'Light',
    apiCallsInProgress: 0,
  },
};

const reducer = (
  state: ConfigState = initialState,
  action: ConfigAction = { type: actionTypes.BEGIN_API_CALL },
): ConfigState => {
  const calls = state?.ui?.apiCallsInProgress;
  switch (action.type) {
    case actionTypes.BEGIN_API_CALL: {
      return {
        ...state,
        ui: {
          ...state.ui,
          apiCallsInProgress: calls + 1,
        },
      };
    }
    case actionTypes.END_API_CALL: {
      return {
        ...state,
        ui: {
          ...state.ui,
          apiCallsInProgress: calls > 0 ? calls - 1 : calls,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
